import { render, staticRenderFns } from "./HelpArticles.vue?vue&type=template&id=0432e5ba&scoped=true"
var script = {}
import style0 from "./HelpArticles.vue?vue&type=style&index=0&id=0432e5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0432e5ba",
  null
  
)

export default component.exports